import { createSlice } from '@reduxjs/toolkit';
import {  
    getAllGLGFiles,
    downloadGLG,
    getAllAssets,
    saveGroupsAssets,
    getApcmGroup,
    getAllGroups,
    saveUser,
    searchGroupName,
    getUserDetail,
    getApcmUserId,
    savPriceReqest,
    getAllPriceRequests,
    getRequestID,
    getExecutersData,
    priceByPage,
    getRoles,
    getRequestByGroupIds,
    getYesRequestByGroupIds,
    getExecutedLogss,
    getLogsByID,
    getAssetsLiveData,
    getAssetsCount,
    getGroupsCount,
    getUsersCount,
    getPricesCount,
    getExecutedCounts,
    getPriceCountsByID,
    getExecutedCountsByID,
    getPriceReqRaisedDataByID,
    getExecutedDatasByID,
    getConfirmedReq,
    getGroupInfo,
    getNoConfirmedCount,
    getNoExecutedCount,
    getNoExecutedData,
    getNoConfirmedData,
    getUsersUnitCount,
    executedAllRequest,
    executedAllRequestByID,
    getRetryRequests,
    getCancelRequests,
    updateExecuteRequest,
} from './dataSourceActions';

const initialState = {
    panels: [],
    tags: [],
    GLGFiles: [],
    glgDownloadURL: null,
    assets:[],
    saveGroups:[],
    searchedGroup:[],
    getGroups:[],
    getGroupsbyId:[],
    user:[],
    getUserD:[],
    getUsersbyId:{},
    prices:[],
    getPriceRequest:[],
    getRequestsbyId:[],
    executersData: [],
    priceByPage: [],
    getRole:[],
    getPriceRequestById:[],
    getYesRequestById:[],
    getYesPriceRequestById:[],    
    getExecLogs: [],
    getExecLogsByID:[],
    assetData : [],
    latestExecDataByID:[],
    raisedDataByID:[],
    confirmedReq:[],
    Count:{
        asset:[],
        groups:[],
        users:[],
        raisedRequest:[],
        reqExecuted:[],
        raisedRequestID:[],
        reqExecutedID:[],
        noConfirmed:[],
        noExecuted:[],
        unitsCount:[],
    },
    noConfirmedData:[],
    noExecutedData:[],
    groupsInfo:[],
    allExecReq:[],
    allExecReqByID:[],
    retriedRequest:[],
    canceledRequest:[],
    priceExecuteMsg: null,
};

export const dataSourceSlice = createSlice({
    name: 'dataSourceSlice',
    initialState,
    reducers: {
        clearDataSource: state => {
            return {
                ...state,
                getGroupsbyId: [],
                getUsersbyId:{},
                getRequestsbyId:[],
                
            };
        },
        clearDowntime: state => {
            return {
                ...state,
                priceExecuteMsg: null,
            };
        },
        clearDataSourcePanel: (state, action) => {
            return {
                ...state,
                panels: state.panels.filter(
                    panel => panel.panelId !== action.payload?.panelId,
                ),
            };
        },
        clearPriceRequestMsg: state => {
            return {
                ...state,
                downtime: [],
            };
        }
    },
    extraReducers: builder => {
        builder      
            .addCase(getAllGLGFiles.fulfilled, (state, action) => {
                const files = [];
                action.payload.map(glgFile => {
                    files.push(glgFile.file_name);
                });
                return {
                    ...state,
                    GLGFiles: [...files],
                };
            })

         

            .addCase(downloadGLG.fulfilled, (state, action) => {
                return {
                    ...state,
                    glgDownloadURL: action.payload,
                };
            })
           
            .addCase(getRoles.fulfilled, (state, action) => {
                return {
                    ...state,
                    getRole: action.payload,
                };
            })
            .addCase(getAssetsLiveData.fulfilled, (state, action) => {
                const assetdata = [];
                const { data, panelId } = action.payload;
                const keys = Object.keys(data);

                keys.forEach(item => {
                    assetdata.push({
                        ...data[item].field_data,
                        ...data[item].tag_data,
                        asset_id: item,
                    });
                });

                const panels = [...state.panels];
                const index = panels.findIndex(
                    item => item.panelId === panelId,
                );
                if (index >= 0) {
                    panels[index] = { assetdata, panelId };
                } else {
                    panels.push({ assetdata, panelId });
                }
                state.panels = panels;
            })
          
            .addCase(getAllAssets.fulfilled, (state, action) => {
                return {
                    ...state,
                    assets: action.payload,
                };
            })
            .addCase(getGroupInfo.fulfilled, (state, action) => {
                return {
                    ...state,
                    groupsInfo: action.payload,
                };
            })
            .addCase(getAllGroups.fulfilled, (state, action) => {
                return {
                    ...state,
                    getGroups: action.payload,
                };
            })
            .addCase(getExecutersData.fulfilled, (state, action) => {
                return {
                    ...state,
                    executersData: action.payload,
                };
            })
            .addCase(getAllPriceRequests.fulfilled, (state, action) => {
                return {
                    ...state,
                    getPriceRequest: action.payload,
                };
            })
            .addCase(priceByPage.fulfilled, (state, action) => {
                return {
                    ...state,
                    priceByPage: action.payload,
                };
            })
            .addCase(saveGroupsAssets.fulfilled, (state, action) => {
                return {
                    ...state,
                    saveGroups:[...state.saveGroups,action.payload]
                };
            })
            .addCase(saveUser.fulfilled, (state, action) => {
                return {
                    ...state,
                    user:[...state.user,action.payload]
                };
            })
            .addCase(savPriceReqest.fulfilled, (state, action) => {
                return {
                    ...state,
                    prices:[...state.prices,action.payload]
                };
            })
            .addCase(searchGroupName.fulfilled, (state, action) => {
                return {
                    ...state,
                    searchedGroup:action.payload
                };
            })
            .addCase(getApcmGroup.fulfilled, (state, action) => {
                return {
                    ...state,
                    getGroupsbyId:action.payload
                };
                
            })
            .addCase(getRequestByGroupIds.fulfilled, (state, action) => {
                return {
                    ...state,
                    getPriceRequestById:action.payload
                };
                
            })
            .addCase(getYesRequestByGroupIds.fulfilled, (state, action) => {
                return {
                    ...state,
                    getYesPriceRequestById:action.payload
                };
                
            })
            .addCase(getExecutedLogss.fulfilled, (state, action) => {
                return {
                    ...state,
                    getExecLogs:action.payload
                };
                
            })

            .addCase(getLogsByID.fulfilled, (state, action) => {
                return {
                    ...state,
                    getExecLogsByID:action.payload
                };
                
            })
            .addCase(getUserDetail.fulfilled, (state, action) => {
               
                    state.getUserD=[...action.payload]
               
            })
            .addCase(getApcmUserId.fulfilled, (state, action) => {
                return {
                    ...state,
                    getUsersbyId:action.payload
                };
            })
            .addCase(getRequestID.fulfilled, (state, action) => {
                return {
                    ...state,
                    getRequestsbyId:action.payload
                };
            })
            .addCase(getExecutedDatasByID.fulfilled, (state, action) => {
                return {
                    ...state,
                    latestExecDataByID:action.payload
                };
            })
            .addCase(getPriceReqRaisedDataByID.fulfilled, (state, action) => {
                return {
                    ...state,
                    raisedDataByID:action.payload
                };
            })
            .addCase(getConfirmedReq.fulfilled, (state, action) => {
                return {
                    ...state,
                    confirmedReq: action.payload,
                };
            })
            .addCase(getNoConfirmedData.fulfilled, (state, action) => {
                return {
                    ...state,
                    noConfirmedData:action.payload
                };
            })
            .addCase(getNoExecutedData.fulfilled, (state, action) => {
                return {
                    ...state,
                    noExecutedData:action.payload
                };
            })
            .addCase(executedAllRequest.fulfilled, (state, action) => {
                return {
                    ...state,
                    allExecReq:action.payload
                };
            })
            .addCase(executedAllRequestByID.fulfilled, (state, action) => {
                return {
                    ...state,
                    allExecReqByID:action.payload
                };
            })
            .addCase(getAssetsCount.fulfilled, (state, action) => {
                const asset  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, asset },
                };
            })
            .addCase(getGroupsCount.fulfilled, (state, action) => {
                const groups  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, groups },
                };
            })
            .addCase(getUsersCount.fulfilled, (state, action) => {
                const users  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, users },
                };
            })
            .addCase(getPricesCount.fulfilled, (state, action) => {
                const raisedRequest  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, raisedRequest },
                };
            })
            .addCase(getNoExecutedCount.fulfilled, (state, action) => {
                const noExecuted  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, noExecuted },
                };
            })
            .addCase(getNoConfirmedCount.fulfilled, (state, action) => {
                const noConfirmed  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, noConfirmed },
                };
            })
            .addCase(getExecutedCounts.fulfilled, (state, action) => {
                const reqExecuted  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, reqExecuted },
                };
            })
            .addCase(getPriceCountsByID.fulfilled, (state, action) => {
                const raisedRequestID  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, raisedRequestID },
                };
            })
            .addCase(getExecutedCountsByID.fulfilled, (state, action) => {
                const reqExecutedID  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, reqExecutedID },
                };
            })
            .addCase(getUsersUnitCount.fulfilled, (state, action) => {
                const unitsCount  = action.payload;
                return {
                    ...state,
                    Count: { ...state.Count, unitsCount },
                };
            })
            .addCase(getRetryRequests.fulfilled, (state, action) => {
                return {
                    ...state,
                    retriedRequest:action.payload
                };
            })
            .addCase(getCancelRequests.fulfilled, (state, action) => {
                return {
                    ...state,
                    canceledRequest:action.payload
                };
            })
            .addCase(updateExecuteRequest.fulfilled, (state, action) => {
                return {
                    ...state,
                    priceExecuteMsg:action.payload
                };
            });
    },
});

export const getPanelValues = state => state.datasource.panels;

export const getAssets = state => state.datasource.assets;

export const getGroups = state => state.datasource.getGroups;

export const getCounts = state => state.datasource.Count;

export const getPriceRequestById = state => state.datasource.getPriceRequestById;

export const getYesPriceRequestByIds = state => state.datasource.getYesPriceRequestById;

export const getPriceRequest = state => state.datasource.getPriceRequest;

export const getAllRoles = state => state.datasource.getRole;

export const getPriceByPage = state => state.datasource.priceByPage;

export const getGroupBySearch = state => state.datasource.searchedGroup;

export const getGroupsInfo = state => state.datasource.groupsInfo;

export const getAssetData = state => state.datasource.assetData;

export const getRaisedDataByID = state => state.datasource.raisedDataByID;

export const getExecutersRequest = state => state.datasource.executersData;

export const getRequestByID = state => state.datasource.getRequestsbyId;

export const getUser = state => state.datasource.user;

export const getConfirmedReqData = state => state.datasource.confirmedReq;

export const getlatestExecDataByID = state => state.datasource.latestExecDataByID;

export const getUserDetails = state => state.datasource.getUserD;

export const getGroupsbyId = state => state.datasource.getGroupsbyId;

export const getExecuteLogs = state => state.datasource.getExecLogs;

export const getExecuteLogsByID = state => state.datasource.getExecLogsByID;

export const getUsersbyId = state => state.datasource.getUsersbyId;

export const getNotConfirmed = state => state.datasource.noConfirmedData;

export const getNotExecuted = state => state.datasource.noExecutedData;

export const getAllExecReq = state => state.datasource.allExecReq;

export const getAllExecReqByID = state => state.datasource.allExecReqByID;

export const getRetriedRequests = state => state.datasource.retriedRequest;

export const getCanceledRequest = state => state.datasource.canceledRequest;

export const getPanelValue = (state, panelId) => {
    const panels = state.datasource.panels;
    return panels.filter(panel => panel.panelId === panelId)[0];
};

export const { clearDataSource, clearDowntime, clearDataSourcePanel, clearPriceRequestMsg } =
    dataSourceSlice.actions;

export const getGLGFiles = state => state.datasource.GLGFiles;

export const getGLGDashboard = state => state.datasource.glgDashboard;


export default dataSourceSlice.reducer;
